import { AdminTitle } from "../../../../store/reducers/site"
// lib
import { useState, useRef ,useEffect} from 'react';
import { useFormik, FieldArray, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom'


import { errorHelper, Loader } from '../../../../utils/tools'
import { validation, formValues } from './shopValidationSchema'

// redux
import { useDispatch, useSelector } from 'react-redux';
import { addShop ,getAllategory} from "../../../../store/actions/shopAction";

// MUI
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button' 
import Divider from '@mui/material/Divider' 
//import Chip from '@mui/material/Chip'
//import Paper from '@mui/material/Paper'
//import InputBase from '@mui/material/InputBase'
//import IconButton from '@mui/material/IconButton'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
 
import InputLabel from '@mui/material/InputLabel';
//import AddIcon from '@mui/icons-material/Add';
//import { visuallyHidden } from '@mui/utils';


const AddShops = () => { 
    const [editorBlur,setEditorBlur] = useState(false);
    // redux
    const shop = useSelector(state=>state.shopReducer);
    const users = useSelector(state=>state.users)
    const dispatch = useDispatch();

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    
    
    let navigate = useNavigate();


   

    const formik = useFormik({
        enableReinitialize:true,
        initialValues: formValues,
        validationSchema:validation,
        onSubmit:(values)=>{
           
            values.mcatId=selectedCategory.mcatId;
           

            dispatch(addShop(values))
            .unwrap()
            .then((response)=>{
       
                if(response!=null)
                {
                    if(response.message==='success')
                    {
                   const id=response.id
                     //navigate(`/dashboard/shops/contn/${id}`)
                     navigate(`/dashboard/shops/contn/${id}`, { replace: true }); 
                    }
                }


                
            })
        }
    })

   



   
    const handleChange = (id) => {
      
        // console.log("66666666666666");
        // console.log(id.target.value);
        // console.log("66666666666666");
        setSelectedSubcategory(shop.mCategories)

  
        
        console.log(selectedSubcategory);

       
    

        
        

        const value123 =id.target.value;
       
        
        const filtered = selectedSubcategory.filter(user => user.mcatId===value123);
             

               //setSelectedCategory(id.target.value)    
               setSelectedCategory(filtered[0])    
              
             
               
    }

   

    useEffect(()=>{
        
      dispatch(getAllategory({}))
        //dispatch(getShopSubCategory({}))
        
    },[])
   

    return(
        <>
        <AdminTitle title="Add Shop"/>
       
        <form className='mt-3 news_form' onSubmit={formik.handleSubmit}>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="shopName"
                    label="ENTER SHOP NAME "
                    variant="outlined"
                    {...formik.getFieldProps('shopName')}
                    {...errorHelper(formik,'shopName')}


                  
                   
                />
            </div>
            

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="shopTitle"
                    label="ENTER SHOP TITLE  "
                    variant="outlined"
                    {...formik.getFieldProps('shopTitle')}
                    {...errorHelper(formik,'shopTitle')}


                  
                   
                />
            </div>

            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select the  language</InputLabel>
                <Select
                    name="languageType"
                    label="Select a language"
                    {...formik.getFieldProps('languageType')}
                    error={ formik.errors.languageType && formik.touched.languageType ? true:false}
                >
                   <MenuItem value= {0}><em>None</em></MenuItem>
                    <MenuItem value={1}>ENGLISH</MenuItem>
                    <MenuItem value={2}>KANNADA</MenuItem>
                </Select>
                { formik.errors.languageType && formik.touched.languageType ?
                    <FormHelperText error={true}>
                        { formik.errors.languageType}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>


<div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="score"
                    label="ENTER OWNER  MOBILE NUMBER "
                    variant="outlined"
                    {...formik.getFieldProps('phNo')}
                    {...errorHelper(formik,'phNo')}
                />
            </div>



            
            <Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>Select a category</InputLabel>
                <Select
                
                    name="mcatId"
                    label="Select a category"
                    {...formik.getFieldProps('mcatId')}
                    error={ formik.errors.mcatId && formik.touched.mcatId ? true:false}
                   onChange={(e) => handleChange(e)}
                >
                    { shop.mCategories ? 
                    
                    shop.mCategories.map(item=>(
                       // setSelectedSubcategory(item),
                        <MenuItem key={item.mcatId} value={item.mcatId}>
                            {item.discription}
                            
                            
                        </MenuItem>

                
                        
                    ))
                :null}
                </Select>
                { formik.errors.mcatId && formik.touched.mcatId ?
                    <FormHelperText error={true}>
                        { formik.errors.mcatId}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>


            <Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>SELECT SUB CATEGORY </InputLabel>
                <Select
                    name="subcatId"
                    label="SELECT SUB CATEGORY "
                    {...formik.getFieldProps('subcatId')}
                    error={ formik.errors.subcatId && formik.touched.subcatId ? true:false}
                >
                    { selectedCategory ? 
                  //selectedSubcategory.findIndex(x => x.mcatId === 1) .subcateList.map(item=>(
                    selectedCategory.subcateList.map(item=>(
                        <MenuItem key={item.subcatId} value={item.subcatId}>
                            {item.discription}
                        </MenuItem>
                       // console.log("UUUUUUUUU")
                    ))
                :null}
                </Select>
                { formik.errors.subcatId && formik.touched.subcatId ?
                    <FormHelperText error={true}>
                        { formik.errors.subcatId}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>

{/* 
            <div className='form-group'>
                <WYSIWYG
                    setEditorState={(state)=>handleEditorState(state)}
                    setEditorBlur={(blur)=> handleEditorBlur(blur)}
                    onError={formik.errors.content}
                    editorBlur={editorBlur}
                />
                { formik.errors.content || (formik.errors.content && editorBlur) ?
                    <FormHelperText error={true}>
                        {formik.errors.content}
                    </FormHelperText>
                    :null
                }
            </div> */}

<div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="identity"
                    label="ENTER THE LANDMARK "
                    variant="outlined"
                    {...formik.getFieldProps('identity')}
                    {...errorHelper(formik,'identity')}


                  
                   
                />
            </div>
                    
                    

            
            

           
           
                 

            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
            
                <InputLabel>Select your District</InputLabel>
                <Select
                    name="districtID"
                    label="Select your District"
                    {...formik.getFieldProps('districtID')}
                    error={ formik.errors.districtID && formik.touched.districtID ? true:false}
                >
                     <MenuItem value={1}><em>KOLAR</em></MenuItem>
                    <MenuItem value={2}>BENGALURU</MenuItem>
                </Select>
                { formik.errors.districtID && formik.touched.districtID ?
                    <FormHelperText error={true}>
                        { formik.errors.districtID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select your Taluk</InputLabel>
                <Select
                    name="talukID"
                    label="Select your talukID"
                    {...formik.getFieldProps('talukID')}
                    error={ formik.errors.talukID && formik.touched.talukID ? true:false}
                >
                    
                    <MenuItem value={1}><em>MALUR</em></MenuItem>
                </Select>
                { formik.errors.talukID && formik.touched.talukID ?
                    <FormHelperText error={true}>
                        { formik.errors.talukID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>




            <Divider className='mt-3 mb-3'/>
          
          
            { shop.loading ?
                    <Loader/>
                :
                <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    Add Shop
                </Button>
                }

        </form>

    </>
    )

}
export default AddShops;
